import { Meta } from '@appbolaget/aware-model';

export class MetaInterface {
    hasMeta = false;
    meta: Array<Meta> = [];

    setMeta(meta): void {
        this.hasMeta = true;
        this.meta = [];

        if (meta.constructor === Object) {
            for (const key in meta) {
                if (meta[key].value !== null) {
                    this.meta.push(new Meta(meta[key]));
                }
            }
        } else if (meta.constructor === Array) {
            for (const obj of meta) {
                this.meta.push(new Meta(obj));
            }
        }
    }

    createMeta(key, value): void {
        const meta = new Meta({ key, value });
        this.meta.push(meta);
    }

    deleteMetaByKey(key): void {
        this.meta = this.meta.filter((meta) => meta.key !== key);
    }

    updateMeta(meta: Object): void {
        for (const key in meta) {
            if (meta[key]) {
                for (const obj of this.meta) {
                    if (obj.key === key) {
                        obj.value = meta[key];
                        continue;
                    }
                }
            }
        }
    }

    getMetaField(metaKey, substitute: any = false) {
        if (!this.meta) {
            return substitute;
        }

        for (const obj of this.meta) {
            if (metaKey === obj.key) {
                return obj;
            }
        }

        return substitute;
    }

    getMetaFields(metaKey, substitute: any = []) {
        if (!this.meta) {
            return substitute;
        }

        const ret = [];

        for (const obj of this.meta) {
            if (metaKey === obj.key) {
                ret.push(obj);
            }
        }

        return ret;
    }

    getMetaFieldValue(metaKey: string, substitute: any = '') {
        if (!this.meta) {
            return substitute;
        }

        for (const obj of this.meta) {
            if (metaKey === obj.key) {
                if (obj.value === '') {
                    return substitute;
                }

                return obj.value;
            }
        }

        return substitute;
    }

    getMetaFieldsValue(metaKey, substitute: any = []) {
        if (!this.meta) {
            return substitute;
        }

        const ret = [];

        for (const obj of this.meta) {
            if (metaKey === obj.key) {
                ret.push(obj.value);
            }
        }

        return ret;
    }
}
